'use client'

import type { NavigationItemProps } from '@maestro/commerce-blocks/components/navigation-footer/navigation-footer.types'

import classNames from 'classnames'
import React from 'react'

import { useNavigationItem } from '@maestro/commerce-blocks/components/navigation-footer/batons/use-navigation-item'
import { Link } from '@pearlconvert/ui/components/link'

export default function NavigationItem(props: NavigationItemProps) {
  const { childNode, sectionTitle } = props
  const { handleClickLink } = useNavigationItem({ childNode, sectionTitle })

  return (
    <li className="footer__nav-item">
      {childNode.url === '' ? (
        <span className={classNames(childNode.cssClass)}>
          {childNode.title}
        </span>
      ) : (
        <Link
          href={childNode.url}
          target={childNode.target}
          className={classNames('footer__nav-link', childNode.cssClass)}
          onClick={handleClickLink}
        >
          {childNode.title}
        </Link>
      )}
    </li>
  )
}
